<!-- Content -->
<div
  class="tw-w-full tw-mx-auto tw-flex tw-flex-col tw-gap-6 tw-px-2 sm:tw-px-0 sm:tw--mx-4 sm:tw-w-[calc(100%+28px)] tw-bg-color-surface-card"
>
  <!-- Top card matching design (wrapped to allow outside decorations) -->
  <div class="tw-relative tw-rounded-3xl tw-bg-teal-950 tw-p-[1.2px]">
    <!-- top card -->
    <div class="tw-bg-color-surface-card tw-rounded-3xl tw-shadow-sm tw-overflow-hidden">
      <div
        class="tw-relative tw-flex tw-items-center tw-justify-between tw-bg-gradient-to-r tw-from-teal-950 tw-to-teal-700 tw-text-color-text-on-dark tw-px-4 tw-h-[72px] tw-rounded-t-3xl tw-gap-6"
      >
        <div class="tw-flex tw-items-center">
          <div
            class="tw-p-2 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-bg-color-accent-today-bg"
          >
            <icon
              class="tw-translate-x-[1px]"
              [name]="'gift'"
              [size]="7"
              [currentColor]="'white'"
            ></icon>
          </div>
          <div class="tw-ml-3">
            <div class="tw-font-medium tw-text-[16px] sm:tw-text-[14px]">
              {{ i18n.t("redemptionTitle") }}
            </div>

            <div class="tw-text-[13px] sm:tw-text-[12px] tw-opacity-90">
              {{ i18n.t("redemptionBundleName") }}
            </div>
          </div>
        </div>

        <div class="tw-flex tw-items-center">
          <div
            class="tw-px-[24px] tw-py-1 tw-rounded-md tw-text-color-text-on-dark tw-text-3xl tw-font-bold tw-transform tw-translate-x-3"
          >
            {{ ITEM_MULTIPLIER }}
          </div>
        </div>

        <!-- Dotted line -->
        <div class="tw-absolute tw-top-0 tw-bottom-0 tw-right-[80px] dotted-line"></div>
      </div>

      <!-- Content area -->
      <div class="tw-py-6 tw-flex tw-flex-col tw-items-center tw-bg-color-accent-today-bg">
        <div class="tw-text-[36px] tw-text-color-text-default tw-font-semibold">
          {{ POINTS_DISPLAY }}
        </div>
        <div
          class="tw-text-[14px] tw-text-color-text-action tw-uppercase tw-tracking-wider tw-mt-1 tw-font-semibold tw-mb-4"
        >
          {{ i18n.t("redemptionCredits") }}
        </div>
        <div class="tw-flex tw-w-full tw-flex-col">
          <div class="tw-h-px tw-w-full tw-bg-white/[.82]"></div>
          <div class="tw-h-px tw-w-full tw-bg-black/10"></div>
        </div>
        <div
          class="tw-w-full tw-flex tw-justify-between tw-items-center tw-px-5 tw-mt-4 tw-h-[32px]"
        >
          <span class="tw-text-[14px] tw-text-color-text-tertiary">{{
            i18n.t("redemptionRemainingBalance")
          }}</span>
          <div
            class="tw-text-[14px] tw-text-color-text-default tw-font-normal tw-flex tw-items-baseline tw-gap-1"
          >
            <span class="tw-text-[24px] tw-text-color-text-default tw-font-semibold">{{
              remainingPoints() | number
            }}</span>
            <span>CrG</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <!-- Collapsible sections: focus-card/-trigger (base.scss) draws the header's keyboard focus outline
       round the whole card, so it grows with the card when the section opens. Inset
       (focus-card-inset): on phones the cards reach the dialog's edge, which would clip it. -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-rounded-3xl tw-shadow-card-item">
    <!-- actual card (inner layer) -->
    <div
      class="focus-card focus-card-inset tw-rounded-3xl tw-bg-color-surface-card tw-overflow-hidden"
    >
      <!-- What you get (collapsible) -->
      <div
        class="focus-card-trigger tw-w-full tw-flex tw-justify-between tw-items-center tw-px-5 tw-py-4 tw-cursor-pointer tw-rounded-3xl"
        role="button"
        tabindex="0"
        (click)="toggleWhat()"
        (keydown.enter)="!$any($event).repeat && toggleWhat()"
        (keyup.space)="toggleWhat()"
        (keydown.space)="$event.preventDefault()"
        [attr.aria-expanded]="isWhatOpen()"
      >
        <div class="tw-flex tw-flex-row sm:tw-flex-col tw-items-center sm:tw-items-start tw-gap-2">
          <span class="tw-text-[16px] tw-font-extrabold">{{ i18n.t("redemptionWhatYouGet") }}</span>

          <span class="tw-text-[14px] tw-text-color-text-tertiary">{{
            i18n.t("redemptionOnAussieBundle")
          }}</span>
        </div>
        <div>
          <icon [name]="isWhatOpen() ? 'up-arrow' : 'down-arrow'" [size]="8"></icon>
        </div>
      </div>

      <div [class.open]="isWhatOpen()" class="collapse-container">
        <div class="tw-px-4 tw-pb-4 tw-text-sm tw-text-color-text-tertiary">
          <div class="tw-bg-color-surface-page tw-rounded-lg tw-p-4">
            <div class="tw-font-medium tw-mb-3 tw-text-[14px]">
              {{ i18n.t("redemptionViewBundleDetails") }}
            </div>
            <ul class="tw-pl-1 tw-flex tw-flex-col tw-gap-3 tw-list-none">
              <li *ngFor="let key of whatYouGetItems" class="tw-flex tw-items-center tw-gap-2">
                <span class="tw-text-color-text-action tw-font-bold tw-text-[14px]">✓</span>
                {{ i18n.t(key) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- How it works (collapsible) -->
  <div class="tw-flex tw-flex-col tw-gap-6 tw-rounded-3xl tw-shadow-card-item tw-mb-4">
    <!-- actual card (inner layer) -->
    <div
      class="focus-card focus-card-inset tw-rounded-3xl tw-bg-color-surface-card tw-overflow-hidden"
    >
      <!-- Header -->
      <div
        class="focus-card-trigger tw-w-full tw-flex tw-justify-between tw-items-center tw-px-5 tw-py-4 tw-cursor-pointer tw-rounded-3xl"
        role="button"
        tabindex="0"
        (click)="toggleHow()"
        (keydown.enter)="!$any($event).repeat && toggleHow()"
        (keyup.space)="toggleHow()"
        (keydown.space)="$event.preventDefault()"
        [attr.aria-expanded]="isHowOpen()"
      >
        <div
          class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-items-start tw-gap-1 sm:tw-gap-2"
        >
          <span class="tw-text-[16px] tw-font-extrabold">{{ i18n.t("redemptionHowItWorks") }}</span>
        </div>
        <div>
          <icon [name]="isHowOpen() ? 'up-arrow' : 'down-arrow'" [size]="8"></icon>
        </div>
      </div>

      <div [class.open]="isHowOpen()" class="collapse-container">
        <div class="tw-px-4 tw-pb-4 tw-text-sm tw-text-color-text-tertiary">
          <div class="tw-bg-color-surface-page tw-rounded-lg tw-p-4">
            <ul class="tw-pl-1 tw-flex tw-flex-col tw-gap-3 tw-list-none tw--translate-x-[5px]">
              <li *ngFor="let item of howItWorksItems" class="tw-flex tw-items-center tw-gap-2">
                <span class="tw-text-color-text-action tw-font-bold tw-text-[14px]">
                  <icon [name]="item.icon" [size]="6" [currentColor]="'white'"></icon>
                </span>
                {{ i18n.t(item.key) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
